import React, {useEffect, useState} from 'react'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import useManageOrder from './useManageOrder';
import CircularProgress from '@mui/material/CircularProgress';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { formatDate } from '../../utils/dateUtils';
import IconButton from '@mui/material/IconButton';
import { toast } from 'react-toastify';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';

const BillProcess = () => {

  const IconComponent = (params) => {
    return (
      <>
        <IconButton onClick={() => handleProcess(params.data.uuid)}>
          <DoubleArrowIcon style={{ color: "blue" }} />
        </IconButton>
      </>
    );
  };

  const LinkRenderer = (params) => {
    return (
      <div>
        <a target="_blank" href={params.data.billUrl}>{params.data.billUrl}</a>
      </div>
    )
  }
  
  const {isLoading, getAllProcessOrders, updateProcessOrder} = useManageOrder()
  const [rowData, setRowData] = useState([])
  const [allOrders, setAllOrders] = useState()
  const [showTotal, setShowTotal] = useState(false)
  const [filterType, setFilterType] = useState('ทั้งหมด'); // Add filter state
  
  const [columnDefs, setColumnDefs] = useState([
    { headerName: 'Contact', field: 'contact', flex: 1 },
    { headerName: 'ชื่อหน้ากล่อง', field: 'smileNameInput', flex: 1 },
    { headerName: 'Link', field: 'billUrl', flex: 1, cellRenderer: LinkRenderer },
    { field: 'action', cellRenderer: IconComponent, flex : 1},
  ]);

  const handleProcess = async (orderId) => {
    const result = await updateProcessOrder(orderId);
    if (result) {
      const response = await getAllProcessOrders()
      setAllOrders(response)
      toast.success("Update Successfully"); 
    } else {
      toast.error("มีบางอย่างผิดพลาด!!"); 
    }
  };

  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
  };

  const handlePendingClicked = () => {
    processRecords(false)
    setShowTotal(false)
    setColumnDefs([
      { headerName: 'Contact', field: 'contact', flex: 1 },
      { headerName: 'ชื่อหน้ากล่อง', field: 'smileNameInput', flex: 1 },
      { headerName: 'Link', field: 'billUrl', flex: 1, cellRenderer: LinkRenderer },
      { field: 'action', cellRenderer: IconComponent, flex : 1},
    ]); 
  }

  const handleTotalClicked = () => {
    processRecords(true)
    setShowTotal(true);
    setColumnDefs([
      { headerName: 'Contact', field: 'contact', flex: 1 },
      { headerName: 'ชื่อหน้ากล่อง', field: 'smileNameInput', flex: 1 },
      { headerName: 'Link', field: 'billUrl', flex: 1, cellRenderer: LinkRenderer },
      { headerName: 'วันที่ส่งบิล', field: 'processDate', flex: 1 },
      { field: 'action', cellRenderer: IconComponent, flex : 1},
    ]);
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllProcessOrders()
      console.log(response)
      setAllOrders(response)
    }
    fetchData()
  },[])

  const processRecords = (showTotalParam) => {
    if (allOrders && allOrders.length > 0) {
      const formattedRecords = allOrders.map(record => {
        return {
          ...record,
          contact: record.CustomerProfile ? record.CustomerProfile.contact : null,
          billUrl: record ? record.billUrl : null,
          smileNameInput: record ? record.smileNameInput : null,
          processDate: record ? formatDate(record.processDate, true) : null
        };
      });
      
      let filteredRecords;
      if (showTotalParam) {
        filteredRecords = formattedRecords;
      } else {
        filteredRecords = formattedRecords.filter(record => record.processDate === '');
      }
      
      // Apply billUrl filter
      if (filterType === 'Mercari Shop') {
        filteredRecords = filteredRecords.filter(record => 
          record.billUrl && record.billUrl.toLowerCase().includes('mercari')
        );
      } else if (filterType === 'Rakuten') {
        filteredRecords = filteredRecords.filter(record => 
          record.billUrl && record.billUrl.toLowerCase().includes('rakuten')
        );
      }
      // For 'ทั้งหมด', no additional filtering needed
      
      setRowData(filteredRecords);
    }
  };

  useEffect(() => {
    processRecords(showTotal);
  }, [allOrders, filterType, showTotal]); // Add filterType and showTotal to dependencies

  return (
    <div className="ag-theme-alpine mx-auto" style={{ width: '1200px' }}>
      <div className='flex justify-between items-center mb-4'>
        <h2>รายการที่ต้องส่งบิล</h2>
        {isLoading && <CircularProgress />}
      </div>
      
      {/* Filter and Button Section */}
      <div className='flex items-center gap-4 mb-4'>
        <Box sx={{ minWidth: 200 }}>
          <FormControl fullWidth size="small">
            <InputLabel>Filter by Shop</InputLabel>
            <Select
              value={filterType}
              label="Filter by Shop"
              onChange={handleFilterChange}
            >
              <MenuItem value="ทั้งหมด">ทั้งหมด</MenuItem>
              <MenuItem value="Rakuten">Rakuten</MenuItem>
              <MenuItem value="Mercari Shop">Mercari Shop</MenuItem>
            </Select>
          </FormControl>
        </Box>
        
        <button 
          className={`text-base font-bold btn ${!showTotal ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'} w-32 cursor-pointer hover:bg-blue-400 hover:text-white`}
          onClick={handlePendingClicked}
          style={{ transition: 'all 0.3s ease' }}>
          รายการรอแจ้ง
        </button>
        <button 
          className={`text-base font-bold btn ${showTotal ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'} w-32 cursor-pointer hover:bg-blue-400 hover:text-white`}
          onClick={handleTotalClicked}
          style={{ transition: 'all 0.3s ease' }}>
          รายการทั้งหมด
        </button>
      </div>
      
      <div style={{ height: '80vh'}}>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={rowData}
          defaultColDef={{ resizable: true }}           
          // other props
        />
      </div>
    </div>
  );
}

export default BillProcess